import { Button, Modal } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Configuration from "../environment";
import { showMessage } from "../services/MessageService";

import "./PubliciteComponent.css";

const PubliciteComponent = (props) => {
  const [sessionId, setSessionId] = useState("");
  const [fileName, setFileName] = useState("");
  const [rsType, setRsType] = useState("")

  const [open,setOpen] = useState(false)

  const fRef = useRef();

  /**
   * upload pubFile by sessionId
   * @param {*} file
   * @returns
   */
  const uploadPubFiles = async (file, rsType) => {
    if(file?.files === null || file?.files.length === 0){
      showMessage(dispatch, "please select a file");
      return Promise.reject({error: "need to choose a file"})
    }
    let fd = new FormData();
    rsType === "carousel" ? Array.from(file.files).forEach((f,index)=> fd.append(`pub-rs-${index}`,f)) : fd.append("pub-rs", file.files[0]);

    return axios.post(Configuration.backend_api_url + "/pubs/rs", fd, {
      headers: {
        sessionId,
        Authorization: localStorage.getItem("token"),
      },
    });
  };

  const initSession = async () => {
    return await axios.post(
      Configuration.backend_api_url + "/pubs/init-session",
      null,
      {
        headers: {
          accept: "text/event-stream",
          Authorization: localStorage.getItem("token"),
        },
      }
    );
  };

  const visualiser = async (sessionId, fileName,rsType) => {
    return axios.post(
      Configuration.backend_api_url + "/pubs/visualiser",
      { sessionId, fileName, rsType },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }
    );
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: "START_LOADING" });
    initSession()
      .then((resp) => {
        setSessionId(resp.data);
      }).catch(err=> showMessage(dispatch,err.response.status,"cannot init your session"))
      .finally(() => {
        dispatch({ type: "STOP_LOADING" });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const deployChanges = ()=> {

  }

  const openInNewTab = () => {
    visualiser(sessionId, fileName,rsType).then((resp) => {
      window.open(resp.data);
    }).catch(err=> showMessage(dispatch,err.response.status,"cannot vizualise you upload"));
  };



  const selectRsType = (value)=>{
    setRsType(value)

    let fInput = fRef.current.querySelector("input")
    switch(value){
      case "image":
        fInput.type="file"
        fInput.accept="image/*"
        fInput.click();
        break;
      case "carousel":
        fInput.type="file"
        fInput.accept="image/*"
        fInput.setAttribute("multiple","")
        fInput.click();
        break;
      case "video":
        fInput.type="file"
        fInput.accept="video/*"
        fInput.click();
        break;


    }
  }

  const validateUpload = () =>{
    dispatch({type: "START_LOADING"})
    uploadPubFiles(fRef.current.querySelector("input"), rsType)
    .then((resp) => {
      setFileName(resp.data)
    })
    .finally(()=>{
      dispatch({type: "STOP_LOADING"})
    })}

  const typeIcons = {
    image: "fa-file-image-o",
    carousel: "fa-clone",
    video: "fa-file-video-o",
  };

  return (
    <div className="publicite-workspace">
      <div className="publicite-header">
        <h1>Ressources publicitaires</h1>
        <p>Téléchargez et diffusez vos contenus sur les écrans du réseau</p>
      </div>

      <div className="publicite-layout">
        <div className="publicite-card">
          <div className="publicite-field-label">Type de contenu</div>
          <div className="publicite-type-group">
            <button
              type="button"
              className={"publicite-type-btn" + (rsType === "image" ? " publicite-type-btn-active" : "")}
              onClick={() => selectRsType("image")}
            >
              <i className="fa fa-file-image-o" aria-hidden="true"></i>
              <span>Image</span>
            </button>
            <button
              type="button"
              className={"publicite-type-btn" + (rsType === "carousel" ? " publicite-type-btn-active" : "")}
              onClick={() => selectRsType("carousel")}
            >
              <i className="fa fa-clone" aria-hidden="true"></i>
              <span>Carousel</span>
            </button>
            <button
              type="button"
              className={"publicite-type-btn" + (rsType === "video" ? " publicite-type-btn-active" : "")}
              onClick={() => selectRsType("video")}
            >
              <i className="fa fa-file-video-o" aria-hidden="true"></i>
              <span>Vidéo</span>
            </button>
          </div>

          <Button ref={fRef} className="publicite-dropzone" component="div">
            <input style={{display: "none"}} />
            <div className="publicite-dropzone-icon">
              <i className={`fa ${typeIcons[rsType] || "fa-upload"}`} aria-hidden="true"></i>
            </div>
            <div className="publicite-dropzone-text">
              {rsType === ""
                ? "Choisissez d'abord un type de contenu ci-dessus"
                : "Cliquez pour choisir un autre fichier"}
            </div>
          </Button>

          <div className="publicite-actions">
            <Button
              variant="contained"
              color="primary"
              onClick={validateUpload}
            >
              Valider l'envoi
            </Button>
          </div>

          <div className="publicite-divider"></div>

          <div className="publicite-deploy-row">
            <div>
              <div className="publicite-deploy-title">Prêt à diffuser ?</div>
              <div className="publicite-deploy-subtitle">Vérifiez le rendu avant de déployer sur les écrans</div>
            </div>
            <div className="publicite-deploy-actions">
              <Button
                variant="outlined"
                disabled={fileName === ""}
                onClick={openInNewTab}
              >
                Visualiser
              </Button>
              <Button
                variant="contained"
                className="publicite-deploy-btn"
                disabled={fileName === ""}
                onClick={()=>setOpen(true)}
              >
                Déployer
              </Button>
            </div>
          </div>
        </div>

        <div className="publicite-session-card">
          <div className="publicite-field-label">Session</div>
          <div className="publicite-session-id">
            <span>ID DE SESSION</span>
            <code>{sessionId || "—"}</code>
          </div>

          <div className="publicite-divider"></div>

          <div className="publicite-field-label">Fichiers envoyés</div>
          <ul className="publicite-file-list">
            {fileName === "" ? (
              <li className="publicite-file-empty">Aucun fichier envoyé pour l'instant</li>
            ) : (
              fileName.split(",").map((f, i) => (
                <li key={i}>
                  <i className="fa fa-file-o" aria-hidden="true"></i>
                  <span>{f}</span>
                  <i className="fa fa-check-circle publicite-file-ok" aria-hidden="true"></i>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>

      <Modal open={open} className="deploy-pub-alert" onClose={() => setOpen(false)}>
         <div className="pub-content">
            <div className="message">
              <i className="fa fa-warning fa-2x" />
              <span>Are u sure about deploying this version ?</span>
            </div>

            <div className="pub-toolbar">
              <Button color="primary" variant="outlined" onClick={deployChanges}>Valider</Button>
              <Button color="secondary" variant="outlined" onClick={()=> setOpen(false)}>Annuler</Button>
            </div>

         </div>
      </Modal>
    </div>
  );
};

export default PubliciteComponent;
